module.exports = __webpack_public_path__ + "img/Prime+_logo_channel_m.1803880c.svg";